import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { faFilter, faCheck, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
// import { SharedRankingListService } from '../shared-ranking-list/shared-ranking-list.service';

@Component({
    selector: 'app-shared-filter',
    templateUrl: './shared-filter.component.html',
    styleUrls: ['./shared-filter.component.scss'],
})
export class SharedFilterComponent implements OnInit {
    @Output() onChange: EventEmitter<any> = new EventEmitter();

    collapse = {};

    /**
     * ActiveFilters armazena uma nova estrutura
     * apenas com nome do filtro e valor selecionado
     * ex: `category: '241'`
     */
    activeFilters = {
        loadStart: '',
    };

    icons = {
        filter: faFilter,
        check: faCheck,
        caretRight: faCaretRight,
    };

    headers = {
        rankingModel: 'Tipo',
        ratingDate: 'Data',
        category: 'Categoria',

        year: 'Ano',
        local: 'Local',
        region: 'Região',
        situationId: 'Situação do Torneio',
    };

    modal: NbDialogRef<unknown>;

    /**
     * filterList -
     * Lista de filtros para montagem do HTML
     */
    filterList = [];

    constructor(private modalService: NbDialogService) { }

    ngOnInit(): void { }

    @Input('filter') set filter(filters) {
        if (!filters) return; //filters é undefined antes do recebimento da api

        // se filterList já existir
        if (this.filterList.length) {
            // preciso deletar os filtros que serão substituidos
            for (const newFilter of filters) {
                const upComingKey = this.getKey(newFilter); //ex: upComingKey = 'category'

                // Procuro no array qual o index do objeto
                // que tem a key igual ao upComingKey
                const filterIndexToDelete = this.filterList.findIndex((filterFromList) => {
                    const filterKey = this.getKey(filterFromList);
                    return filterKey === upComingKey;
                });

                //Agora eu removo ele (pra substituir com o que vem da api)
                this.filterList.splice(filterIndexToDelete, 1);
            }

            /* prettier-ignore */
            this.filterList = [
                ...this.filterList, // como eu só deletei o que veio de novo, eu salvo de novo os filtros anteriores ao loadStart
                ...filters // esse aqui é o filtro novo
            ];
        } else {
            this.filterList = [...filters];
        }

        /**
         * TODO: fix-me
         * para fazer com o que o collapse fechado
         * só aconteça uma vez, verifica-se o loadStart vazio
         */
        if (!this.activeFilters.loadStart) this.hideCollapses();

        /* Salva os filtros ativos */
        this.activeFilters = this.storeActiveFilters(filters);
    }

    /**
     * Faz com que o collapse apareça fechado.
     *
     * collapse está verificando quem está
     * aberto/fechado através do index.
     *
     * O código abaixo mapea todos os index
     * para true, que indica que o collapse está ativo,
     * o conteúdo está oculto
     *
     * !collapse é um objeto, não confundir com array
     * ex da estrutura final:
     * collapse {
     *  0: true,
     *  1: true
     * }
     */
    private hideCollapses() {
        for (let index in Array.from(Array(this.filterList.length))) {
            this.collapse[index] = true;
        }
    }

    /**
     * !changelog 02/11
     * Procura na lista de filtros que vem na API
     * quais estão selecionados e cria uma nova estrutura
     * apenas com nome do filtro e valor selecionado
     * ou nome do filtro e array de valores para filtros
     * de multipla escolha
     * ex: `category: '241'`
     * ex2: `region: [2, 5]`
     */
    private storeActiveFilters(filterList) {
        if (!filterList) {
            throw Error('Necessario passar os filtros da api para o componente shared-filter');
        }

        const activeFromAPI = filterList.reduce((acc, cur) => {
            const key = this.getKey(cur);
            const filter = cur[key];
            if (!filter.list) return acc;
            if (filter.type === 2) {
                // type {2: checkbox }

                // procura itens selecionados e atribui ao nome do filtro
                // ex: region: [3, 8], sendo 3 e 8 ids de regiões selecionadas
                const arrOfCheckboxValues = this.getCheckboxValues(filter);

                acc[key] = arrOfCheckboxValues;
            } else {
                const selectedRadio = filter.list.find((radio) => radio.selected);
                acc[key] = selectedRadio.id;
            }

            return acc;
        }, {});

        /* Salva filtros selecionados pela api e deixa loadStart vazio, inicialmente */
        return {
            ...this.activeFilters,
            ...activeFromAPI,
        };
    }

    getCheckboxValues(filter: any) {
        const selectedCheckbox = filter.list.filter((checkbox) => checkbox.selected);
        const arrOfCheckboxValues = selectedCheckbox.reduce((acc, cur) => [...acc, cur.id], []);
        return arrOfCheckboxValues;
    }

    /**
     * TODO: Melhorar documentação e explicar necessidade
     * de tudo que acontece aqui ou sugerir mudança na API
     */
    onChangeEvt(event) {
        const { value, checked } = event.target;
        const filter = JSON.parse(value);
        /* o valor que emitiu o evento passa a ser o loadStart */
        this.activeFilters.loadStart = filter.loadStart;

        const filterIndexToModifySelected = this.filterList.findIndex((filterItem) => {
            const key = this.getKey(filterItem);
            return key === filter.loadStart;
        });

        if (filter.type === 2) {
            // Seleciona checkbox manualmente
            const filterGroup = this.filterList[filterIndexToModifySelected][filter.loadStart];
            const optionIndexToSelect = filterGroup.list.findIndex((option) => option.id === filter.value);
            if (checked) {
                filterGroup.list[optionIndexToSelect].selected = 1;
            } else {
                filterGroup.list[optionIndexToSelect].selected = 0;
            }
            // Atribui grupo modificado de volta
            this.filterList[filterIndexToModifySelected][filter.loadStart] = filterGroup;
            // Salva opções selecionadas
            const arrOfCheckboxValues = this.getCheckboxValues(filterGroup);
            this.activeFilters[filter.loadStart] = arrOfCheckboxValues;
        } else {
            this.filterList[filterIndexToModifySelected][filter.loadStart].list.map(
                (option) => (option.selected = option.id === filter.value)
            );
            this.activeFilters[filter.loadStart] = filter.value;
        }

        this.emitFilter({ loadAll: 0 });
    }

    onFilterBtnClick() {
        this.emitFilter({ loadAll: 1 });
        this.modal.close();
    }
    /**
     * emitFilter()
     * emite evento onChange com filtros selecionados
     */
    emitFilter({ loadAll = 1 }) {
        this.onChange.emit({
            ...this.activeFilters,
            loadAll,
        });
    }

    /* A key é dinamica, preciso descobrir qual é essa key para acessa-la */
    getOptionsByUnkownKey(filter) {
        const key = this.getKey(filter);
        /* Retorna lista de opções */
        return filter[key].list;
    }

    getKey(filter) {
        // Retorno ex: Objeto 1: [ranking_model], Objeto2: [rating_date];
        const [key] = Object.keys(filter);
        return key;
    }

    makeValue(option, filter) {
        return JSON.stringify({
            value: option.id,
            loadStart: this.getKey(filter),
            type: filter[this.getKey(filter)].type,
        });
    }

    openModal(content) {
        this.modal = this.modalService.open(content);
    }

    closeModal() {
        this.modal.close();
    }

    getHeader(filter) {
        const key = this.getKey(filter);
        return filter[key].label;
    }

    getSelected(filter) {
        const key = this.getKey(filter);

        return this.activeFilters[key] instanceof Array ? this.activeFilters[key].length : 1;
    }
}
